if (!customElements.get('gof-device-picker')) {
  customElements.define('gof-device-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const model = this.querySelector('[data-device-model]');
      const custom = this.querySelector('[data-device-custom]');
      const details = this.querySelector('[data-device-details]');
      const sync = () => {
        const isCustom = model.value === 'Özel ölçü';
        custom.hidden = !isCustom;
        custom.disabled = !isCustom;
        details.hidden = isCustom || !model.value;
        details.querySelector('input').disabled = isCustom || !model.value;
      };
      model.addEventListener('change', sync);
      this.querySelectorAll('input[type="text"]').forEach(input => {
        input.addEventListener('input', () => input.setCustomValidity(input.value.trim() ? '' : 'Model yılı veya kodunu yazın.'));
      });
      const form = this.closest('form');
      if (form) form.addEventListener('submit', event => {
        sync();
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          form.reportValidity();
        }
      }, true);
      sync();
    }
  });
}
